export const TableColumns = [
  { key: 'sn', label: '' },
  { key: 'action', label: 'Action' },
  { key: 'custId', label: 'Cust #' },
  { key: 'customerName', label: 'Company' },
  { key: 'markUp', label: 'Mark Up' },
  { key: 'address', label: 'Address' },
  { key: 'cityName', label: 'City' },
  { key: 'stateName', label: 'State' },
  { key: 'phone', label: 'Phone' },
  { key: 'smcName', label: 'SMC' },
];
